import util from '@bmp-vue/core/api/util'

const controller = 'Contas'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetDigito: function (numeroConta) {
    return util.Axios.Get(controller + '/GetDigito', numeroConta)
  },
  GetContasPorParceiro: function (dto) {
    return util.Axios.GetAll(controller + '/ListarPorParceiro', dto)
  },
  GetContaSaldo: function (id) {
    return util.Axios.Get(controller + '/GetContaSaldo', id)
  },
  GetContaExtrato: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetContaExtrato', dto)
  },
  GetContaPgto: function (codigoConta) {
    return util.Axios.Get(controller + '/GetContaPgto', codigoConta)
  },
  RelatorioSaldo: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioSaldo', dto)
  },
  GetContaMovimentos: function (dto) {
    return util.Axios.GetAll(controller + '/GetContaMovimentos', dto)
  },
  FecharConta: function (id) {
    return util.Axios.Put(controller + '/FecharConta', id)
  },
  RelatorioContas: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioContas', dto)
  },
  RelatorioDivergenciasCadastrais: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioDivergenciasCadastrais', dto)
  },
  ComboContas: function (dto) {
    return util.Axios.GetAll(controller + '/ComboContas', dto)
  },
  GetSolicitacoesEncerramento: function (dto, options) {
    return util.Axios.GetAll(controller + '/Encerramento', dto);
  },
  SolicitarEncerramentoConta: function (dto) {
    return util.Axios.Post(controller + '/Encerramento', dto);
  },
  CancelarSolicitacaoEncerramento: function (dto) {
    return util.Axios.Delete(controller + '/Encerramento', dto)
  },
  HistoricoEncerramentoConta: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Encerramento/Historico', dto)
  },
  GetRelatorioContaPDF: function (dto) {
    return util.Axios.GetBlob(controller + '/GetRelatorioContaPDF', dto);
  },
  GetRelatorioSaldoPDF(dto, options) {
    return util.Axios.GetBlob(controller + '/GetRelatorioSaldoPDF', dto);
  },
  ObterModeloCobrancaTaxaConfigurada() {
    return util.Axios.Get(controller + '/ObterModeloCobrancaTaxa');
  },
})
